// tslint:disable-next-line:no-var-requires
export const moment = require("moment");

export const API_DATE_FORMAT = "YYYY-MM-DD";

export const DATE_FORMAT = "DD-MM-YYYY";
export const TIME_FORMAT = "HH:mm";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
